import React, {useState} from 'react';

const Asset = ({asset, handleRemoveAssetTag, handleAppendAssetTag}) => {
    const [inputText, setInputText] = useState("");
    const [inputSuggestions, setInputSuggestions] = useState([]);

    const defaultSuggestions = asset.suggestions.map(suggestion => suggestion.text);

    const handleInputText = (e) => {
        const targetValue = e.target.value;
        setInputText(targetValue);

        // console.log(defaultSuggestions)
        const match = defaultSuggestions.filter(element => element.includes(targetValue));
        // console.log(match)
        targetValue ? setInputSuggestions(match) : setInputSuggestions([]);
    };

    const handleKeyPress = (e) => {
        if (!inputText) {
            return;
        }
        if (e.key === "Enter") {
            const newTag = {id: inputText, text: inputText};
            handleAppendAssetTag(asset, newTag);
            setInputText("");
        }
    };

    return (
        <div className="p-2 border rounded-md shadow">
            <div className="flex flex-col items-center">
                <img
                    className="p-2 mb-2"
                    src={asset.url}/>
                <div className="text-lg mb-2">{asset.title}</div>

                <div className="flex mb-2">
                    <input className="border px-2"
                           type="text"
                           value={inputText}
                           placeholder="create and append a tag"
                           onChange={handleInputText}
                           onKeyPress={handleKeyPress}/>
                </div>

                <div className="flex flex-col items-center mb-4">
                    {inputSuggestions.length > 0 && <div className="text-sm text-gray-500">Suggest Tags:</div>}
                    {inputSuggestions.map(suggest =>
                        <div key={suggest.id}
                             className="mr-2">
                            {suggest}
                        </div>,
                    )}
                </div>

                {asset.tags.map(tag => <div className="bg-gray-300 px-2 mb-2 flex" key={tag.id}>
                    <span className="mr-2">{tag.text}</span>
                    <button onClick={() => handleRemoveAssetTag(asset, tag)}>x</button>
                </div>)}

            </div>
        </div>
    );
};

export default Asset;